var render = function render(){var _vm=this,_c=_vm._self._c;return _c('trax-ui-simple-table',{directives:[{name:"show",rawName:"v-show",value:(_vm.rows.length),expression:"rows.length"}],attrs:{"id":_vm.id,"header":0,"rows":_vm.rows,"cols":_vm.cols,"bus":_vm.bus}})
}
var staticRenderFns = []

export { render, staticRenderFns }